import { FC } from 'react';

import Image from 'next/image';

import { SFFooterViewModel } from '@api/index';
import { APP_STATIC } from '@config/app-static';
import { currentYear } from '@utils/dateUtil';

import { FooterLink, FooterText, LinkWrapper, Wrapper } from './styled';

export interface IFooterLinks {
  corporateLinks: SFFooterViewModel['footerLinks'];
}

const FooterLinks: FC<IFooterLinks> = ({ corporateLinks }) => {
  if (
    !corporateLinks ||
    (corporateLinks &&
      Array.isArray(corporateLinks) &&
      corporateLinks.length === 0)
  ) {
    return null;
  }

  return (
    <Wrapper>
      <Image
        src={APP_STATIC.app_logo}
        width={140}
        height={60}
        style={{
          objectFit: 'contain',
          backgroundColor: '#2F3137',
          borderRadius: '8px',
          padding: 12,
        }}
        alt='Logo'
      />
      <FooterText>Copyright ©{currentYear} Tüm Hakları Saklıdır.</FooterText>
      <LinkWrapper>
        {corporateLinks?.map((item, i) => (
          <FooterLink
            href={item?.href || '#'}
            data-testid='footer-links'
            key={`${item.name}-${i}`}
          >
            {item.name}
          </FooterLink>
        ))}
      </LinkWrapper>
    </Wrapper>
  );
};

export default FooterLinks;
